import react, { useEffect, useContext } from 'react';
import IframePortal from '../../elements/IframePortal';
import h from '../../../helpers/common';
import { MixpanelContext } from '../../../contexts/MixpanelContext';
import { EVENT } from '../../../contexts/MixpanelConstants';

type IMixpanelContext = {
    track?: (name: string, value: any) => void;
};

const MandatoryConsent = ({ question }) => {
    const { track } = useContext(MixpanelContext) as IMixpanelContext;

    useEffect(() => {
        track(EVENT.CONSENT.CONSENT_TC_VIEW, {});
    }, []);

    if (!question?.url) return <h2>Error while loading data.</h2>;

    return <IframePortal src={question.url.replace('{lang}', h.getLang())} />;
};

export default MandatoryConsent;
